/**
 * @description: 预定列表
 * @author: lyr
 */
<template>
	<div>
		<div class="book-order" v-show="showList==1">
			<div class="row row-margin">
				<label class="list-label-4">预定时间:</label>
				<div class="col-md-3 list-time">
					<div @click="clearDate" ref="time">
						<input type="text" class="form-control laydate-icon" :value="startTime"> -
						<input type="text" class="form-control laydate-icon" :value="endTime">
					</div>
				</div>
				<label class="list-label-4">消费门店:</label>
				<div class="col-md-2 ct-col">
					<select class="form-control" ref="shop" data-placeholder="请选择门店"></select>
				</div>
				<label class="list-label-4">包厢区域:</label>
				<div class="col-md-2 ct-col">
					<select class="form-control" data-placeholder="请选择包厢区域" ref="order_room_area"></select>
				</div>
				<label class="list-label-4">包厢类型:</label>
				<div class="col-md-2">
					<div class="input-group">
						<input type="text" class="form-control" placeholder="请选择包厢类型" ref="room_type">
						<div class="input-group-btn">
							<ul class="dropdown-menu dropdown-menu-right" role="menu"></ul>
						</div>
					</div>
				</div>
			</div>
			<div class="row row-margin">
				<label class="list-label-3">包厢号:</label>
                <div class="col-md-2 ct-col">
                    <select class="form-control" data-placeholder="请选择包厢号" ref="book_room"></select>
                </div>
				<label class="list-label-4">预定员工:</label>
				<div class="col-md-2">
					<div class="input-group">
						<input type="text" class="form-control" ref="order_staff" placeholder="请选择预定员工" />
						<div class="input-group-btn">
							<ul class="dropdown-menu dropdown-menu-right" role="menu"></ul>
						</div>
					</div>
				</div>
                <label class="list-label-4">客户姓名:</label>
				<div class="col-md-2">
					<div class="input-group">
						<input type="text" class="form-control" placeholder="请输入客户姓名" ref="ordername" v-model="customer_name">
						<div class="input-group-btn">
							<ul class="dropdown-menu dropdown-menu-right" role="menu"></ul>
						</div>
					</div>
				</div>
				<label class="list-label-4">客户电话:</label>
				<div class="col-md-2">
					<div class="input-group">
						<input type="text" class="form-control" placeholder="请输入客户手机号" ref="ordername" v-model="customer_contact">
						<div class="input-group-btn">
							<ul class="dropdown-menu dropdown-menu-right" role="menu"></ul>
						</div>
					</div>
				</div>
			</div>
			<div class="row row-margin">
				<label class="list-label-3">状态:</label>
				<div class="col-md-2 ct-col">
					<select class="form-control" ref="use_status" data-placeholder="请选择使用状态">
						<option value=" ">全部</option>
						<option value="1">未开房</option>
						<option value="2">已开房</option>
						<option value="-1">已作废</option>
					</select>
				</div>
				<label class="list-label-2">备注:</label>
				<div class="col-md-2">
					<div class="input-group">
						<input type="text" class="form-control" placeholder="请输入备注" ref="remark" v-model="remark">
						<div class="input-group-btn">
							<ul class="dropdown-menu dropdown-menu-right" role="menu"></ul>
						</div>
					</div>
				</div>	
				<label class="list-label-6">预定到店时间:</label>
				<div class="col-md-3 list-time">
					<div @click="clearArriveDate" ref="arriveTime">
						<input type="text" class="form-control laydate-icon" :value="book_start_time"> -
						<input type="text" class="form-control laydate-icon" :value="book_end_time">
					</div>
				</div>	
				<label class="list-label-2">班次:</label>
				<div class="col-md-2 ct-col">
					<select class="form-control" ref="banci" data-placeholder="请选择班次"></select>
				</div>		
			</div>
			<div class="row row-margin">
				<div class="pull-right">
					<button type="button" class="btn btn-flat btn-small btn-orange" @click="clkQuery">查询</button>
					<button type="button" class="btn btn-flat btn-small btn-border-gray" @click="getExportSet">导出</button>
				</div>
			</div>
			<!-- <div class="row">
			</div> -->
			<div class="table-responsive">
				<table class="table table-bordered table-hover" data-pagination="true" ref="book_list"></table>
			</div>
			<!-- 导出设置弹窗 -->
			<div class="ele-hide" ref="export_alert">
				<div class="set-export sel-seldiv">
					<h3>请选择导出报表需要的显示的字段</h3>
					<ul class="set-area clearfix">
						<li>
							<input type='checkbox' v-model='export_allcheck' @click='exportCheckedAll'>
							<label>全选</label>
						</li>
						<li>
							<input type="checkbox" v-model='export_checkModel' value="book_no">
							<label>预定号</label>
						</li>
						<li>
							<input type="checkbox" v-model='export_checkModel' value="create_time">
							<label>预定时间</label>
						</li>
						<li>
							<input type="checkbox" v-model='export_checkModel' value="room_area">
							<label>包厢区域</label>
						</li>
						<li>
							<input type="checkbox" v-model='export_checkModel' value="room_type">
							<label>包厢类型</label>
						</li>
						<li>
							<input type="checkbox" v-model='export_checkModel' value="room_name">
							<label>包厢号</label>
						</li>
						<li>
							<input type="checkbox" v-model='export_checkModel' value="book_admin_name">
							<label>预定员工</label>
						</li>
						<li>
							<input type="checkbox" v-model='export_checkModel' value="customer_name">
							<label>客户姓名</label>
						</li>
						<li>
							<input type="checkbox" v-model='export_checkModel' value="customer_contact">
							<label>客户电话</label>
						</li>
						<li>
							<input type="checkbox" v-model='export_checkModel' value="customer_num">
							<label>到店人数</label>
						</li>
						<li>
							<input type="checkbox" v-model='export_checkModel' value="book_time">
							<label>预定到店时间</label>
						</li>
						<li>
							<input type="checkbox" v-model='export_checkModel' value="status">
							<label>状态</label>
						</li>
						<li>
							<input type="checkbox" v-model='export_checkModel' value="remark">
							<label>备注</label>
						</li>
						<li>
							<input type="checkbox" v-model='export_checkModel' value="shift_name">
							<label>班次</label>
						</li>
					</ul>
					<h3>请选择导出报表的文件格式</h3>
					<ul class="clearfix">
						<li>
							<input type="radio" v-model='export_type' value="1">
							<label>excel表格</label>
						</li>
						<li>
							<input type="radio" v-model='export_type' value="2">
							<label>pdf文件</label>
						</li>
					</ul>
				</div>
			</div>
		</div>
		<!-- 订单详情 -->
		<div class="book-detail-wrap" v-show="showList==2">
			<div class="page-tit">预定详情</div>
			<div class="bkd-con clearfix">
	            <div class="col-md-5">
	                <label class="col-md-3">门店：</label>
	                <span class="col-md-9">{{theOrder.shop_name}}</span>
	                <label class="col-md-3">预定号：</label>
	                <span class="col-md-9">{{theOrder.book_no}}</span>
	                <label class="col-md-3">客户姓名：</label>
	                <span class="col-md-9">{{theOrder.customer_name}}</span>
	                <label class="col-md-3">客户电话：</label>
	                <span class="col-md-9">{{theOrder.customer_contact}}</span>
	                <label class="col-md-3">预定到店时间：</label>
	                <span class="col-md-9">{{theOrder.book_time}}</span>
	                <label class="col-md-3">到店人数：</label>
	                <span class="col-md-9">{{theOrder.customer_num}}</span>
	                <label class="col-md-3">备注：</label>
	                <span class="col-md-9">{{theOrder.remark}}</span>
	            </div>
	            <div class="col-md-5">
	                <label class="col-md-3">预定时间：</label>
	                <span class="col-md-9">{{theOrder.create_time}}</span>
	                <label class="col-md-3">包厢区域：</label>
	                <span class="col-md-9">{{theOrder.room_area_name}}</span>
	                <label class="col-md-3">包厢类型：</label>
	                <span class="col-md-9">{{theOrder.room_type_name}}</span>
	                <label class="col-md-3">包厢号：</label>
	                <span class="col-md-9">{{theOrder.room_name}}</span>
	                <label class="col-md-3">预定员工：</label>
	                <span class="col-md-9">{{theOrder.book_admin_name}}</span>
	                <label class="col-md-3">状态：</label>
	                <span class="col-md-9">{{theOrder.status_name}}</span>
	            </div>
	        </div>
	        <div class="book-det-oper">
	            <div class="title" style="margin-bottom: 30px;">操作日志</div>
	            <div class="table-responsive" style="padding: 0;margin-bottom:30px">
	                <table id="oper_table" class="table table-bordered table-hover" data-pagination="true" ref="oper_table"></table>
	            </div>
	        </div>
			<div>
				<button type="button" class="btn btn-flat btn-middle btn-border-gray" @click="showList=1">返回</button>
			</div>
		</div>
		<!-- 账单详情 -->
		<div class="bill-detail-wrap" v-show="showList==3">
            <billDetail ref="bill_detail" @backBdwPre="showList=1"></billDetail>
        </div>
	</div>
</template>

<script>
	import Vue from 'vue';
	import billDetail from '@/components/bill_detail.vue';
	export default {
		data() {
			return {
				showList: 1,
				startTime: "",
				endTime: "",
				roomTypeData: "",
				orderStaffDatas: [],
				customer_name: '', // 客户姓名
				customer_contact: '',// 客户电话
				remark: '', // 备注
				book_start_time: '', // 预定到店开始时间
				book_end_time: '',// 预定到店结束时间

				theOrder: {}, // 订单详情
				theOpers: [], // 订单操作日志

				export_allcheck: false,
				c_export_allcheck: false,
				export_checkModel: [],
				export_checkData: ['book_no', 'create_time', 'room_area', 'room_type', 'room_name', 'book_admin_name', 'customer_name', 'customer_contact', 'customer_num', 'book_time', 'status', 'shift_name', 'remark'],
				export_type: 1,
			}
		},
		components: {
			"billDetail": billDetail
		},
		watch: {
			export_checkModel: {
				handler: function(val, oldVal) {
					if(this.export_checkModel.length >= this.export_checkData.length) {
						this.export_allcheck = true;
						this.c_export_allcheck = true;
					} else {
						this.export_allcheck = false;
						this.c_export_allcheck = false;
					}
				},
				deep: true
			},
		},
		mounted: function() {
			this.$nextTick(function() {
				var _this = this;
				// 日期
				_this.startTime = moment().hour(8).minute(0).format('YYYY-MM-DD HH:mm');
				_this.endTime =  moment().add(1, 'day').hour(8).minute(0).format('YYYY-MM-DD HH:mm');
				this.innitDate();

				this.getShopData();
				$(this.$refs.use_status).select2({
					language: "zh-CN",
					allowClear: true,
					minimumResultsForSearch: -1,
					width: '100%'
				});
			});
		},
		methods: {
			// 清空日期
			clearDate: function() {
				this.startTime = "";
				this.endTime = "";
			},
			clearArriveDate() {
				this.book_start_time = ''
				this.book_end_time = ''
			},
			// 初始化日期插件
			innitDate: function() {
				let _this = this;
				$(_this.$refs.time).daterangepicker({
					timePicker: true,
					timePickerIncrement: 1,
					timePicker12Hour: false,
					buttonClasses: ['btn btn-default'],
					applyClass: 'btn-small btn-orange',
					cancelClass: 'btn-small btn-gray',
					startDate: moment().hour(8).minute(0).toDate(),
					endDate: moment().add(1, 'day').hour(8).minute(0).toDate()
				}, function(start, end, label) {
					_this.startTime = start.format('YYYY-MM-DD HH:mm');
					_this.endTime = end.format('YYYY-MM-DD HH:mm');
				});

				$(_this.$refs.arriveTime).daterangepicker({
					timePicker: true,
					timePickerIncrement: 1,
					timePicker12Hour: false,
					buttonClasses: ['btn btn-default'],
					applyClass: 'btn-small btn-orange',
					cancelClass: 'btn-small btn-gray',
					startDate: moment().hour(8).minute(0).toDate(),
					endDate: moment().add(1, 'day').hour(8).minute(0).toDate()
				}, function(start, end, label) {
					_this.book_start_time = start.format('YYYY-MM-DD HH:mm');
					_this.book_end_time = end.format('YYYY-MM-DD HH:mm');
				});
			},
			// 获取门店数据
			getShopData: function() {
				let _this = this;

				let datas = {
					"header": Vue.request_header,
					"request": {
						"version": Vue.version,
						"param": {
							
						}
					},
					"comment": ""
				};
				let datas2 = JSON.stringify(datas);
				$.ajax({
					type: "post",
					dataType: "json",
					url: Vue.ctUrl + "PublicData/api_getShopListByPurview",
					crossDomain: true,
					xhrFields: {
						withCredentials: true
					},
                    data: datas2,
					success: function(data) {
						if(data.response.result_code == "true") {
							let arr = [];
							$.each(data.response.result, function(k, v) {
								arr.push({ id: v.id, text: v.name });
							});
							arr.shift();
							$(_this.$refs.shop).select2({
								data: arr,
								minimumResultsForSearch: -1,
								language: "zh-CN"
							}).on("select2:select", function(e) {
								$(_this.$refs.room_type).val("").trigger('change');
								$(_this.$refs.room_type).attr("data-id", '');
								// 包厢类型
								_this.getRoomTypeData(e.params.data.id);
								// 包厢区域
                                $(_this.$refs.order_room_area).prop("disabled", false);
                                _this.getRoomArea(e.params.data.id);
								// 包厢号
                                $(_this.$refs.book_room).val('').trigger('change');
                                _this.getRoomdata(e.params.data.id);
                                // 预定员工
                                $(_this.$refs.order_staff).prop("disabled", false);
                                $(_this.$refs.order_staff).attr("data-id", '');
                                _this.getOrderStaff(e.params.data.id)
                                 // 班次
	                            $(_this.$refs.banci).prop("disabled", false);
	                            _this.getBanci(e.params.data.id)
							});
							// 包厢类型
							_this.getRoomTypeData($(_this.$refs.shop).val());
							// 包厢区域
                            $(_this.$refs.order_room_area).prop("disabled", false);
                            _this.getRoomArea($(_this.$refs.shop).val());
							// 包厢号
                            $(_this.$refs.book_room).val('').trigger('change');
                            _this.getRoomdata($(_this.$refs.shop).val());
                            // 预定员工
                            $(_this.$refs.order_staff).prop("disabled", false);
                            _this.getOrderStaff($(_this.$refs.order_staff).val())
                            // 班次
                            $(_this.$refs.banci).prop("disabled", false);
                            _this.getBanci($(_this.$refs.shop).val())

							_this.innitTable();
						} else {
							Vue.timeoutfun(data.response.result_status,_this);
							layer.msg(data.response.data.error_msg);
						}
					},
					error: function(err) {
						layer.msg("网络错误");
					}
				});
			},
			// 包厢类型数据
			getRoomTypeData: function(shop_id) {
				let _this = this;
				let datas = {
					"header": Vue.request_header,
					"request": {
						"version": Vue.version,
						"param": {
							"shop_id": shop_id || ""
						}
					},
					"comment": ""
				};
				let datas2 = JSON.stringify(datas);
				$.ajax({
					type: "post",
					dataType: "json",
					url: Vue.ctUrl + "PublicData/api_getRoomType",
					crossDomain: true,
					xhrFields: {
						withCredentials: true
					},
                    data: datas2,
					success: function(data) {
						if(data.response.result_code == "true") {
							_this.roomTypeData = data.response.result.data;
							_this.initRoomType();
						} else {
							Vue.timeoutfun(data.response.result_status,_this);
							layer.msg(data.response.data.error_msg);
						}
					},
					error: function(err) {
						layer.msg("网络错误");
					}
				});
			},
			// 初始化包厢类型
			initRoomType: function() {
				let _this = this;
				$(_this.$refs.room_type).bsSuggest("destroy");
				$(_this.$refs.room_type).bsSuggest({
					data: {
						value: _this.roomTypeData
					},
					ignorecase: true,
					showHeader: false,
					showBtn: false,
					delayUntilKeyup: true,
					effectiveFields: ["name"],
					idField: "id",
					keyField: "name"
				}).on('onSetSelectValue', function(e, keyword, data) {

				});
			},
			// 获取包厢数据
            getRoomdata: function(shop_id) {
                let _this = this;

                let datas = {
                    "header": Vue.request_header,
                    "request": {
                        "param": {
                            "shop_id": shop_id
                        }
                    },
                    "comment": ""
                };
                datas = JSON.stringify(datas);
                $.ajax({
                    type: "POST",
                    dataType: "json",
                    url: Vue.ctUrl + "Shop/getAllRoom",
                    crossDomain: true,
                    xhrFields: {
                        withCredentials: true
                    },
                    data: datas,
                    success: function(data) {
                        if(data['response']['result_code'] == "true") {
                            let roomDatas = [{ id: " ", text: "全部" }];
                            $.each(data['response']['result'], function(k, v) {
                                roomDatas.push({ id: v.id, text: v.name });
                            });
                            $(_this.$refs.book_room).html("");
                            $(_this.$refs.book_room).select2({
                                data: roomDatas,
                                minimumResultsForSearch: -1,
                                language: "zh-CN"
                            });
                        } else {
                            Vue.timeoutfun(data.response.result_status, _this);
                            layer.msg(data["response"]["error_msg"]);
                        }
                    },
                    error: function(err) {}
                });
            },

            // 获取包厢区域
            getRoomArea: function(shop_id) {
                const _this = this
                let datas = {
                    "header": Vue.request_header,
                    "request": {
                        "version": Vue.version,
                        "param": {
                            "shop_id": shop_id
                        }
                    },
                    "comment": ""
                };
                let datas2 = JSON.stringify(datas);
                $.ajax({
                    type: "post",
                    dataType: "json",
                    url: Vue.ctUrl + "Shop/getRoomArea",
                    crossDomain: true,
                    xhrFields: {
                        withCredentials: true
                    },
                    data: datas2,
                    success: function(data) {
                        if(data.response.result_code == "true") {
                            let arr = [{ id: ' ', text: '全部' }];
                            $.each(data.response.result, function(k, v) {
                                arr.push({ id: v.id, text: v.name });
                            });
                            $(_this.$refs.order_room_area).html('');
                            $(_this.$refs.order_room_area).select2({
                                data: arr,
                                allowClear: true,
                                minimumResultsForSearch: -1,
                                language: "zh-CN"
                            });
                        } else {
                            Vue.timeoutfun(data.response.result_status,_this);
                            layer.msg(data.response.data.error_msg);
                        }
                    },
                    error: function(err) {
                        layer.msg("网络错误");
                    }
                });
            },

            // 预定员工数据
			getOrderStaff: function(shop_id) {
				let _this = this;
				let innitSuggest = function() {
					$(_this.$refs.order_staff).bsSuggest("destroy");
					$(_this.$refs.order_staff).bsSuggest({
						data: _this.orderStaffDatas,
						ignorecase: true,
						showHeader: false,
						showBtn: false, // 不显示下拉按钮
						delayUntilKeyup: true, // 获取数据的方式为 firstByUrl 时，延迟到有输入/获取到焦点时才请求数据
						idField: "id",
						keyField: "name",
						effectiveFields: ["name"],
						inputWarnColor: "white", // 输入框内容不是下拉列表选择时的警告色
					});
				};
				let datas = {
					"header": Vue.request_header,
					"request": {
						"version": Vue.version,
						"param": {
							"shop_id": shop_id || "",
						}
					},
					"comment": ""
				};
				let datas2 = JSON.stringify(datas);
				$.ajax({
					type: "post",
					dataType: "json",
					url: Vue.ctUrl + "user/getSearchList",
					crossDomain: true,
					xhrFields: {
						withCredentials: true
					},
                    data: datas2,
					success: function(data) {
						if(data.response.result_code == "true") {
							_this.orderStaffDatas.value = [];
							$.each(data.response.result, function(k, v) {
								_this.orderStaffDatas.value.push({
									id: v.id,
									name: v.name
								});
							});
							if(_this.orderStaffDatas.value.length < 1) {
								$(_this.$refs.order_staff).attr("readonly", "readonly");
							} else {
								$(_this.$refs.order_staff).removeAttr("readonly");
								innitSuggest();
							}
						} else {
							Vue.timeoutfun(data.response.result_status,_this);
							layer.msg(data.response.error_msg);
						}
					},
					error: function(err) {
						layer.msg("出错啦");
					}
				});
			},

			 // 获取门店班次
            getBanci: function(shop_id) {
                const _this = this
                let datas = {
                    "header": Vue.request_header,
                    "request": {
                        "version": Vue.version,
                        "param": {
                            "shop_id": shop_id,
                            "field": "shift_setting" // 查询的门店参数名称
                        }
                    },
                    "comment": ""
                };
                let datas2 = JSON.stringify(datas);
                $.ajax({
                    type: "post",
                    dataType: "json",
                    url: Vue.ctUrl + "Shop/getConfig",
                    crossDomain: true,
                    xhrFields: {
                        withCredentials: true
                    },
                    data: datas2,
                    success: function(data) {
                        if(data.response.result_code == "true") {
                            let arr = [{ id: ' ', text: '全部' }];
                            $.each(data.response.result, function(k, v) {
                                arr.push({ id: v, text: v });
                            });
                            $(_this.$refs.banci).html('');
                            $(_this.$refs.banci).select2({
                                data: arr,
                                minimumResultsForSearch: -1,
                                language: "zh-CN"
                            });
                        } else {
                            Vue.timeoutfun(data.response.result_status,_this);
                            layer.msg(data.response.data.error_msg);
                        }
                    },
                    error: function(err) {
                        layer.msg("网络错误");
                    }
                });
            },

			// 预订单列表
			innitTable: function() {
                let _this = this;
                $(_this.$refs.book_list).bootstrapTable({
                    pageNumber: 1,
                    pageSize: 10,
                    pageList: [],
                    pagination: true,
                    ajax: function(params) {
                        _this.getList(params);
                    },
                    sidePagination: "server",
                    columns: [{
                        field: "book_no",
                        title: "预定号",
                        width: "5%",
                        valign: 'middle'
                    }, {
                        field: "create_time",
                        title: "预定时间",
                        width: "8%",
                        valign: 'middle'
                    }, {
                        field: "room_name",
                        title: "包厢号",
                        width: "6%",
                        valign: 'middle'
                    }, {
                        field: "room_type_name",
                        title: "包厢类型",
                        width: "5%",
                        valign: 'middle'
                    }, {
                        field: "room_area_name",
                        title: "包厢区域",
                        width: "5%",
                        valign: 'middle'
                    }, {
                        field: "book_admin_name",
                        title: "预定员工",
                        width: "8%",
                        valign: 'middle'
                    }, {
                        field: "customer_name",
                        title: "客户姓名",
                        width: "8%",
                        valign: 'middle'
                    }, {
                        field: "customer_contact",
                        title: "客户电话",
                        width: "8%",
                        valign: 'middle'
                    }, {
                        field: "customer_num",
                        title: "到店人数",
                        width: "5%",
                        valign: 'middle'
                    }, {
                        field: "book_time",
                        title: "预定到店时间",
                        width: "8%",
                        valign: 'middle'
                    }, {
                        field: "status_name",
                        title: "状态",
                        width: "5%",
                        valign: 'middle'
                    }, {
                        field: "admin_name",
                        title: "操作人",
                        width: "6%",
                        valign: 'middle'
                    }, {
                        field: "shift_name",
                        title: "班次",
                        width: "5%",
                        valign: 'middle'
                    }, {
                        field: "remark",
                        title: "备注",
                        width: "8%",
                        valign: 'middle'
                    }, {
                        title: "操作",
                        width: "12%",
                        valign: 'middle',
                        events: {
                            'click .detail': function(e, value, row) {
                                _this.getBookDetail(row.id);
								_this.showList = 2;
                            },

                            'click .bill': function(e, value, row) {
                                _this.$refs.bill_detail.getBdwDetail(row.bill_no);
								_this.showList = 3;
                            }
                        },
                        formatter: function(value, row, index) {
                        	if (row.status == 2) {
                        		return '<span class="text-blue detail">详情</span><span class="text-blue bill">账单</span>'
                        	}else{ 
                            	return '<span class="text-blue detail">详情</span>'
                        	}
                        }
                    }],
                });
            },
            // 表格数据
            getList: function(params) {
                let _this = this,
                    shop_id = $(_this.$refs.shop).val(),
                    room_type_id = $(_this.$refs.room_type).attr("data-id") || '',
                    book_admin_id = $(_this.$refs.order_staff).attr("data-id") || '',
                    pageNumber = 1;
                if(params != "" && params.data.offset != 0) {
                    pageNumber = parseInt(params.data.offset / params.data.limit) + 1;
                }
                let datas = {
                    "header": Vue.request_header,
                    "request": {
                        "version": Vue.version,
                        "param": {
                            "page": pageNumber,
                            "page_size": params.data.limit,
                            "start_time": _this.startTime,
                            "end_time": _this.endTime,
                            "shop_id": shop_id || "",
                            "room_area": $.trim($(_this.$refs.order_room_area).val()),
                            "room_type": room_type_id,
                            "room_id": $.trim($(_this.$refs.book_room).val()),
                            "book_admin_id": book_admin_id,
                            "customer_name": _this.customer_name,
                            "customer_contact": _this.customer_contact,
                            "status": $.trim($(_this.$refs.use_status).val()),
                            "remark": _this.remark,
                            "book_start_time": _this.book_start_time,
                            "book_end_time": _this.book_end_time,
                            "shift_name": $.trim($(_this.$refs.banci).val()),
                        }
                    },
                    "comment": ""
                };
                let datas2 = JSON.stringify(datas);
                $.ajax({
                    type: "post",
                    dataType: "json",
                    url: Vue.ctUrl + "Book/getBookList",
                    crossDomain: true,
                    xhrFields: {
                        withCredentials: true
                    },
                    data: datas2,
                    success: function(data) {
                        if(data.response.result_code == "true") {
                            params.success({
                                total: data.response.result.count,
                                rows: data.response.result.data
                            });
                        } else {
                            Vue.timeoutfun(data.response.result_status, _this);
                            layer.msg(data.response.error_msg);
                            params.success({
                                total: 0,
                                rows: 0
                            });
                        }
                    },
                    error: function(err) {
                        layer.msg("出错啦");
                    }
                });
            },
			// 查询
			clkQuery: function() {
				$(this.$refs.book_list).bootstrapTable("destroy");
				this.innitTable();
			},
            // 获取导出设置
			getExportSet: function() {
				let _this = this;
				let datas = {
					"header": Vue.request_header,
					"request": {
						"version": Vue.version,
						"param": {
							"report_type": "Book/exportBook"
						}
					},
					"comment": ""
				};
				let datas2 = JSON.stringify(datas);
				$.ajax({
					type: "post",
					dataType: "json",
					url: Vue.ctUrl + "FinanceReport/getExportSet",
					crossDomain: true,
					xhrFields: {
						withCredentials: true
					},
                    data: datas2,
					success: function(data) {
						if(data.response.result_code == "true") {
							if(data.response.result) {
								_this.export_checkModel = data.response.result.export_fields;
								_this.export_type = data.response.result.export_type;
							} else {
								_this.export_checkModel = _this.export_checkData;
								_this.export_type = 1;
							}
						} else {
							Vue.timeoutfun(data.response.result_status, _this);
							layer.msg(data.response.error_msg);
						}
					},
					error: function(err) {
						layer.msg("出错啦");
					}
				});

				// 弹窗
				layer.confirm('', {
					skin: 'add_printer_area',
					type: 1,
					btn: ['确定', '取消'], // 按钮
					title: ['导出设置', true],
					area: ['830px', ''], // 宽高
					content: $(_this.$refs.export_alert)
				}, function() {
					_this.exportList();
				});
			},
			// 导出字段全选
			exportCheckedAll: function() {
				let _this = this;
				_this.export_allcheck = _this.c_export_allcheck;
				if(!_this.export_allcheck) { // 实现全选
					_this.export_checkModel = [];
					_this.export_checkData.forEach(function(item) {
						_this.export_checkModel.push(item);
					});
				} else { // 实现反选
					_this.export_checkModel = [];
				}
			},
			// 导出
			exportList: function() {
				let _this = this,
					shop_id = $(_this.$refs.shop).val(),
					room_type_id = $(_this.$refs.room_type).attr("data-id") || '',
					book_admin_id = $(_this.$refs.order_staff).attr("data-id") || '';
				let export_fields = JSON.stringify(_this.export_checkModel);
				window.location.href = Vue.ctUrl + "Book/exportBook?" +
					"&start_time=" + _this.startTime +
					"&end_time=" + _this.endTime +
					"&shop_id=" + shop_id +
					"&room_area=" + $.trim($(_this.$refs.order_room_area).val()) +
                    "&room_type=" + room_type_id +
                    "&room_id=" + $.trim($(_this.$refs.book_room).val()) +
                    "&book_admin_id=" + book_admin_id +
                    "&customer_name=" +  _this.customer_name +
                    "&customer_contact=" +  _this.customer_contact +
                    "&status=" + $.trim($(_this.$refs.use_status).val()) +
                    "&remark=" + _this.remark +
                    "&book_start_time=" + _this.book_start_time +
                    "&book_end_time=" + _this.book_end_time +
                    "&shift_name=" + $.trim($(_this.$refs.banci).val()) +
                    "&export_fields=" + export_fields +
					"&export_type=" + _this.export_type;
				//debugger;
				layer.msg("导出成功！");
				layer.closeAll();
			},

			// 获取订单详情
			getBookDetail: function(id) {
                const _this = this;
                let datas = {
                    "header": Vue.request_header,
                    "request": {
                        "version": Vue.version,
                        "param": {
                            "id": id
                        }
                    },
                    "comment": ""
                };
                let datas2 = JSON.stringify(datas);
                $.ajax({
                    type: "post",
                    dataType: "json",
                    url: Vue.ctUrl + "Book/getBookDetail",
                    crossDomain: true,
                    xhrFields: {
                        withCredentials: true
                    },
                    data: {
                        json: datas2
                    },
                    success: function(data) {
                        _this.theOrder = data.response.result;
						// 操作日志
						_this.theOpers = data.response.result.operation_log;
						if(_this.theOpers.length == 0) {
							$('.book-det-oper').hide();
						} else {
							$(_this.$refs.oper_table).bootstrapTable("destroy");
							_this.innitOperTable();
							$('.book-det-oper').show();
						}
					},
				    error: function(err) {
						layer.msg("出错啦");
				    }
				});
			},

			// 初始化订单详情操作表格
			innitOperTable: function() {
				let _this = this;
				$(_this.$refs.oper_table).bootstrapTable({
					pagination: false,
					columns: [{
						field: "create_time",
						title: "操作时间",
						width: "33%"
					}, {
						field: "admin_name",
						title: "操作人",
						width: "33%"
					}, {
						field: "content",
						title: "详情",
						width: "33%"
					}],
					data: _this.theOpers
				});
			},
		}
	}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less">
	.book-order {
		.book-tit-sel {
			width: 90px;
			padding: 0;
		}
		.book-con-val {
			padding-left: 0;
			margin-left: -1px;
		}
		.pull-right {
			button {
				margin: 0 0 0 30px;
			}
		}
		.set-export {
			padding: 0 20px 20px;
			h3 {
				font-size: 16px;
			}
			li {
				float: left;
				width: 20%;
			}
		}
	}
</style>